export const heroHighlights = [
  { id: "movie", label: "电影版", value: "约 118 分钟", desc: "单本叙事，节奏紧凑，适合一次看完" },
  { id: "tv", label: "电视剧版", value: "全 36 集", desc: "人物线索更完整，家庭群像层层展开" },
  { id: "short", label: "短剧版", value: "全 80 集 · 单集 2 分钟", desc: "强冲突快节奏，碎片时间轻松追" },
];

export const versionCards = [
  {
    id: "movie",
    name: "电影版",
    tagline: "一屋两人三代的温柔和解",
    format: "剧情长片",
    duration: "约 118 分钟",
    episodes: "单本",
    image: "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20movie%20poster%20backdrop%20of%20a%20softly%20lit%20modern%20living%20room%20with%20warm%20cream%20walls%20and%20terracotta%20accents%2C%20a%20cozy%20armchair%20and%20floating%20dust%20in%20golden%20afternoon%20light%2C%20elegant%20minimal%20art-house%20film%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20refined%20muted%20color%20grading%2C%20high%20detail&width=600&height=800&seq=nanny-poster-movie-01&orientation=portrait",
    tone: "细腻克制，重情绪铺陈",
    audience: "适合喜欢慢节奏家庭剧的观众",
    highlights: ["完整的三幕式家庭叙事", "注重生活细节与留白", "结尾留有余味，耐人回味"],
  },
  {
    id: "tv",
    name: "电视剧版",
    tagline: "把家长里短讲成一部群像",
    format: "都市家庭剧",
    duration: "单集约 45 分钟",
    episodes: "全 36 集",
    image: "https://readdy.ai/api/search-image?query=Vertical%20warm%20cinematic%20backdrop%20of%20a%20traditional%20family%20dining%20room%20with%20wooden%20table%20and%20linen%20curtains%2C%20soft%20amber%20evening%20lamplight%2C%20delicate%20household%20objects%2C%20art-house%20television%20drama%20aesthetic%2C%20muted%20beige%20and%20rust%20palette%2C%20shallow%20focus%2C%20high%20detail&width=600&height=800&seq=nanny-poster-tv-01&orientation=portrait",
    tone: "生活流叙事，多线交织",
    audience: "适合陪伴式追剧、喜欢群像的观众",
    highlights: ["配角支线丰富，人物弧光完整", "每一集都有独立的小事件", "适合下饭与睡前观看"],
  },
  {
    id: "short",
    name: "短剧版",
    tagline: "两分钟一个转折",
    format: "竖屏短剧",
    duration: "单集约 2 分钟",
    episodes: "全 80 集",
    image: "https://readdy.ai/api/search-image?query=Vertical%20warm%20cinematic%20backdrop%20of%20a%20bright%20sunlit%20kitchen%20with%20ceramic%20bowls%20and%20fresh%20flowers%20on%20a%20wooden%20counter%2C%20soft%20golden%20light%20through%20sheer%20curtains%2C%20modern%20short-drama%20aesthetic%2C%20muted%20cream%20and%20amber%20tones%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=600&height=800&seq=nanny-poster-short-01&orientation=portrait",
    tone: "强冲突快节奏，反转密集",
    audience: "适合碎片时间、喜欢爽感的观众",
    highlights: ["每集结尾都有钩子", "竖屏观看体验更顺手", "追起来毫无压力"],
  },
];

export const synopsisParagraphs = [
  "《漂亮的保姆》围绕一位走入普通家庭的女性展开。她带着利落的手脚与体面的分寸进入这个家，把凌乱的屋子收拾妥当，也在不知不觉间收拾起这家人许久没有面对的情绪与隔阂。",
  "故事并不急着替人物下判断，而是让吃饭、放学、换季收衣这样的小事一件件发生，让关系在这些琐碎里慢慢松动。观众看到的不是某一场爆发，而是一个家庭如何重新学会说话。",
  "作品在电影、电视剧与短剧三种形态中都保留了同一条情感主线：被需要与被理解。不同的时长与节奏，只是换一种方式讲述同一份温柔。",
];

export const themeList = [
  { title: "被看见的照顾者", desc: "全职照顾者常常是家里最沉默的人。作品试图把镜头还给她们，让付出本身被认真对待。", icon: "ri-heart-3-line" },
  { title: "两代人的表达差", desc: "长辈用行动表达，晚辈用语言确认。错位往往不是不爱，而是没找到同一套说法。", icon: "ri-chat-smile-2-line" },
  { title: "边界与亲近", desc: "一个外人如何走进家庭内部，又如何在亲近中守住分寸，是全片反复讨论的命题。", icon: "ri-shield-star-line" },
  { title: "日常的重量", desc: "没有惊天动地的转折，真正改变一个人的，是每天准时端上桌的那一顿热饭。", icon: "ri-home-heart-line" },
];

export const characters = [
  {
    name: "林秋",
    role: "保姆 · 女主",
    tag: "温和而清醒",
    desc: "做事极有条理，说话不多但句句在点上。她善于观察，总能先一步察觉这家人没说出口的需要。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20warm%20composed%20woman%20in%20a%20softly%20lit%20modern%20home%2C%20gentle%20natural%20window%20light%2C%20neutral%20cream%20and%20warm%20beige%20tones%2C%20shallow%20depth%20of%20field%2C%20refined%20art-house%20film%20still%20aesthetic%2C%20calm%20expressive%20mood%2C%20clean%20simple%20background%2C%20high%20detail&width=600&height=750&seq=nanny-char-linqiu-01&orientation=portrait",
  },
  {
    name: "周明远",
    role: "父亲 · 男主人",
    tag: "忙碌与笨拙",
    desc: "把工作当成避风港的中年人，习惯用加班代替沟通。他并非冷漠，只是很久没人教他如何表达。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20tired%20middle-aged%20man%20standing%20in%20a%20dim%20home%20office%2C%20soft%20warm%20lamplight%2C%20muted%20brown%20and%20beige%20palette%2C%20shallow%20depth%20of%20field%2C%20refined%20art-house%20film%20still%20aesthetic%2C%20restrained%20thoughtful%20mood%2C%20clean%20simple%20background%2C%20high%20detail&width=600&height=750&seq=nanny-char-zhoumy-01&orientation=portrait",
  },
  {
    name: "周念念",
    role: "女儿 · 小学生",
    tag: "机灵又敏感",
    desc: "家里最会把情绪说出口的人。她的问题天真直接，却常常一语点破大人绕不开的心事。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20bright%20curious%20young%20girl%20in%20a%20sunlit%20bedroom%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20and%20peach%20tones%2C%20shallow%20depth%20of%20field%2C%20refined%20art-house%20film%20still%20aesthetic%2C%20cheerful%20gentle%20mood%2C%20clean%20simple%20background%2C%20high%20detail&width=600&height=750&seq=nanny-char-zhounn-01&orientation=portrait",
  },
  {
    name: "周奶奶",
    role: "祖母",
    tag: "嘴硬心软",
    desc: "对家里的规矩格外较真，却在细节里藏着偏爱。她把一生的话都放进了一日三餐。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20an%20elderly%20kind%20grandmother%20sitting%20near%20a%20bright%20kitchen%20window%2C%20soft%20warm%20daylight%2C%20muted%20cream%20and%20taupe%20palette%2C%20shallow%20depth%20of%20field%2C%20refined%20art-house%20film%20still%20aesthetic%2C%20gentle%20nostalgic%20mood%2C%20clean%20simple%20background%2C%20high%20detail&width=600&height=750&seq=nanny-char-grandma-01&orientation=portrait",
  },
  {
    name: "苏晴",
    role: "母亲 · 女主人",
    tag: "焦虑而用力",
    desc: "标准意义上的好妈妈，把所有精力都投进家庭。她与林秋之间，是从提防到理解的漫长过程。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20composed%20elegant%20woman%20in%20a%20quiet%20living%20room%2C%20soft%20diffused%20window%20light%2C%20muted%20sage%20and%20cream%20tones%2C%20shallow%20depth%20of%20field%2C%20refined%20art-house%20film%20still%20aesthetic%2C%20pensive%20warm%20mood%2C%20clean%20simple%20background%2C%20high%20detail&width=600&height=750&seq=nanny-char-suqing-01&orientation=portrait",
  },
  {
    name: "小林",
    role: "邻家青年",
    tag: "话多善良",
    desc: "总在楼道里出现的热心邻居，是这家之外唯一看见林秋辛苦的人，也带来了不少轻松的日常。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20friendly%20young%20man%20standing%20in%20a%20bright%20sunlit%20hallway%2C%20soft%20warm%20daylight%2C%20muted%20amber%20and%20cream%20palette%2C%20shallow%20depth%20of%20field%2C%20refined%20art-house%20film%20still%20aesthetic%2C%20relaxed%20cheerful%20mood%2C%20clean%20simple%20background%2C%20high%20detail&width=600&height=750&seq=nanny-char-xiaolin-01&orientation=portrait",
  },
];

export const episodeArcs = [
  {
    range: "第 1-8 集",
    title: "进门：一个外人的到来",
    desc: "林秋走进周家，用一周时间让凌乱的屋子重新有了秩序，也让家庭成员第一次意识到，原来有人的付出是可以量化的。",
    points: ["初次见面时的试探与规矩", "第一顿被认真夸赞的晚饭", "孩子主动靠近的转折"],
  },
  {
    range: "第 9-16 集",
    title: "磨合：谁的家里都有秘密",
    desc: "周明远的加班、苏晴的焦虑、奶奶的口是心非逐一展开。林秋夹在中间，学会了不动声色地化解，也开始被卷入这个家的旧事。",
    points: ["一场没有吵完的争执", "藏在抽屉里的旧照片", "奶奶第一次开口喊她的名字"],
  },
  {
    range: "第 17-26 集",
    title: "裂缝：被误解的照顾者",
    desc: "一次意外的家庭变故让所有积压的情绪浮出水面，林秋成为被指责的对象。她第一次思考，自己到底该不该留下。",
    points: ["误会爆发的那顿晚饭", "念念替她说的一句公道话", "她收拾行李又被留下的夜晚"],
  },
  {
    range: "第 27-36 集",
    title: "和解：把家重新讲一遍",
    desc: "众人重新学习表达与倾听。作品没有给出完美的答案，而是让这个家学会了相处的方式，也给了林秋她一直缺少的尊重。",
    points: ["父女之间迟到的一次对话", "一封写给照顾者的信", "结尾餐桌上的那次举杯"],
  },
];

export const galleryCategories = [
  { id: "all", label: "全部剧照" },
  { id: "home", label: "家庭日常" },
  { id: "kitchen", label: "厨房烟火" },
  { id: "moment", label: "高光时刻" },
];

export const galleryItems = [
  {
    id: "g1",
    category: "home",
    title: "午后客厅",
    desc: "光线穿过纱帘落在沙发上，这是全片最常出现的场景，也是许多对话发生的地方。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20serene%20modern%20living%20room%20in%20soft%20afternoon%20light%2C%20sheer%20curtains%20and%20houseplants%2C%20warm%20cream%20and%20terracotta%20palette%2C%20art-house%20cinematography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=600&seq=nanny-still-01&orientation=landscape",
  },
  {
    id: "g2",
    category: "kitchen",
    title: "灶台前的清晨",
    desc: "一天从切菜声开始。作品用大量厨房细节，交代照顾者日复一日的耐心。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20warm%20morning%20kitchen%20with%20fresh%20vegetables%20on%20a%20wooden%20board%20and%20steam%20rising%2C%20soft%20golden%20light%2C%20muted%20amber%20and%20cream%20palette%2C%20art-house%20cinematography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=600&seq=nanny-still-02&orientation=landscape",
  },
  {
    id: "g3",
    category: "moment",
    title: "雨夜的等待",
    desc: "校门口的一场雨，让等待与守候有了具体的形状，也让关系悄悄靠近了一步。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20rainy%20evening%20street%20outside%20a%20school%20gate%20with%20warm%20streetlight%20reflections%2C%20moody%20soft%20light%2C%20muted%20amber%20and%20deep%20green%20palette%2C%20art-house%20cinematography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=600&seq=nanny-still-03&orientation=landscape",
  },
  {
    id: "g4",
    category: "home",
    title: "餐桌上的三代人",
    desc: "一张桌子坐了四个人，谁都没有先开口。沉默本身也是剧情的一部分。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20family%20dining%20table%20set%20for%20four%20in%20warm%20evening%20lamplight%2C%20ceramic%20tableware%20and%20linen%2C%20muted%20beige%20and%20rust%20palette%2C%20art-house%20cinematography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=600&seq=nanny-still-04&orientation=landscape",
  },
  {
    id: "g5",
    category: "kitchen",
    title: "一起包饺子的傍晚",
    desc: "手上有面粉，话就变多了。这是全片最松弛的段落之一。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20two%20pairs%20of%20hands%20making%20dumplings%20on%20a%20flour-dusted%20wooden%20counter%2C%20warm%20afternoon%20light%2C%20muted%20cream%20and%20peach%20palette%2C%20art-house%20cinematography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=600&seq=nanny-still-05&orientation=landscape",
  },
  {
    id: "g6",
    category: "moment",
    title: "阳台上的那次谈话",
    desc: "她第一次说出自己的想法，对面的人终于安静地听完。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20quiet%20balcony%20at%20dusk%20with%20potted%20plants%20and%20soft%20violet-free%20warm%20sky%2C%20muted%20cream%20and%20terracotta%20palette%2C%20art-house%20cinematography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=600&seq=nanny-still-06&orientation=landscape",
  },
  {
    id: "g7",
    category: "home",
    title: "整理旧物",
    desc: "把积压的箱子一个个打开，也是把回忆一件件重新安放。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20hands%20sorting%20old%20photographs%20and%20folded%20linens%20from%20a%20wooden%20box%20on%20a%20sunlit%20floor%2C%20warm%20dusty%20light%2C%20muted%20brown%20and%20cream%20palette%2C%20art-house%20cinematography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=600&seq=nanny-still-07&orientation=landscape",
  },
  {
    id: "g8",
    category: "moment",
    title: "结尾的举杯",
    desc: "杯子轻轻碰在一起，故事在这里停下，也刚刚开始。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20three%20glasses%20toasting%20gently%20over%20a%20warmly%20lit%20dinner%20table%2C%20soft%20evening%20glow%2C%20muted%20amber%20and%20rust%20palette%2C%20art-house%20cinematography%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=600&seq=nanny-still-08&orientation=landscape",
  },
];

export const watchSteps = [
  { icon: "ri-movie-2-line", title: "挑选版本", desc: "先确定你想要电影版的完整叙事，还是电视剧版与短剧版的连续追更体验。" },
  { icon: "ri-time-line", title: "安排时长", desc: "电影版适合完整的两个小时；短剧版单集仅两分钟，通勤路上也能看上几集。" },
  { icon: "ri-tv-2-line", title: "选择设备", desc: "电影与电视剧版横屏观看更沉浸，短剧版为竖屏拍摄，手机直接观看即可。" },
  { icon: "ri-bookmark-3-line", title: "记录进度", desc: "电视剧版集数较多，建议记住看到的分集，方便下次接着往下看。" },
];

export const viewerReviews = [
  { user: "追剧的栗子", date: "2026-08-02", rating: 5, tag: "电影版", content: "本来只想随便看看，结果一口气看到结尾。它没有大起大落，但每一顿饭都让人鼻子一酸。" },
  { user: "南窗听雨", date: "2026-08-11", rating: 4, tag: "电视剧版", content: "群像写得扎实，奶奶那条线最打动我。缺点是前几集节奏偏慢，耐心看完真的值。" },
  { user: "地铁八号线", date: "2026-08-19", rating: 5, tag: "短剧版", content: "竖屏短剧能做到这个质感挺意外的，反转不尬，泡面时间刚好追两集。" },
  { user: "一勺糖", date: "2026-09-01", rating: 4, tag: "电视剧版", content: "配角比主角还出彩，邻家青年那段承包了我的笑点。适合睡前慢慢看。" },
  { user: "晚风信箱", date: "2026-09-14", rating: 5, tag: "电影版", content: "摄影和色调太舒服了，几乎每一帧都能截图当壁纸，故事克制但后劲很足。" },
  { user: "安静的周末", date: "2026-09-27", rating: 4, tag: "短剧版", content: "节奏是真的快，两分钟一个钩子。适合不想动脑、只想放松的时候刷。" },
];

export const faqList = [
  {
    q: "《漂亮的保姆》一共有几个版本？",
    a: "目前常见的观看形态包含电影版、电视剧版和短剧版三种。三者共享同一条情感主线，区别主要在时长、叙事节奏与人物展开的详略程度上。",
  },
  {
    q: "电影版和电视剧版应该先看哪个？",
    a: "如果时间有限、喜欢完整均匀的叙事，可以从电影版入手；如果你更喜欢人物群像与生活流细节，电视剧版会展开得更充分。两者没有严格的先后顺序。",
  },
  {
    q: "短剧版会不会看不懂剧情？",
    a: "不会。短剧版对每一集都做了相对完整的小事件，即使单独观看也能跟上。它是节奏更快的独立版本，而非电视剧版的删减片段。",
  },
  {
    q: "在哪里可以找到全集完整版的观看入口？",
    a: "本页汇总了各版本的基本信息与观看建议，你可以先在下方的版本一览中确认想看的形式，再安排合适的观看时间。页面说明仅作导览，不提供播放服务。",
  },
  {
    q: "这部剧适合什么年龄段观看？",
    a: "作品聚焦家庭关系与情感表达，整体基调温和。是否适合全家一起观看，建议参考各平台对应的分级与内容提示后自行判断。",
  },
];